'use client';

import { TourProvider as ReactTourProvider } from '@reactour/tour';
import type { ReactNode } from 'react';

interface TourProviderProps {
  children: ReactNode;
}

export function TourProvider({ children }: TourProviderProps) {
  return (
    <ReactTourProvider
      steps={[]}
      styles={{
        popover: (base) => ({
          ...base,
          // backgroundColor: 'hsl(var(--background))',
          backgroundColor: 'var(--rowmantic-blue)',
          // color: 'hsl(var(--foreground))',
          color: 'white',
          borderRadius: '1rem',
          padding: '1rem',
          boxShadow:
            '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
          transition: 'all 0.7s ease-in-out',
        }),
        maskArea: (base) => ({
          ...base,
          rx: 8,
        }),
        // controls: (base) => ({ ...base }),
        button: (base) => ({
          ...base,
          backgroundColor: 'var(-rowmantic-red)',
          color: 'white',
        }),
        arrow: (base) => ({
          ...base,
          backgroundColor: 'var(-rowmantic-red)',
          color: 'white',
        }),
        badge: (base) => ({
          ...base,
          // backgroundColor: 'hsl(var(--primary))',
          backgroundColor: 'var(-rowmantic-red)',
          // color: 'hsl(var(--primary-foreground))',
          color: 'white',
        }),
        close: (base) => ({
          ...base,
          // color: 'hsl(var(--foreground))',
          color: 'white',
        }),
      }}
      padding={{
        mask: 10,
        popover: [10, 10],
      }}
      scrollSmooth
      inViewThreshold={{ x: 10, y: 10 }}
      startAt={0}
      onClickMask={({ setCurrentStep, currentStep, steps, setIsOpen }) => {
        if (steps) {
          if (currentStep === steps.length - 1) {
            setIsOpen(false);
          } else {
            setCurrentStep((s) => (s === steps.length - 1 ? 0 : s + 1));
          }
        }
      }}
    >
      {children}
    </ReactTourProvider>
  );
}
